import React from 'react';
import PropTypes from 'prop-types';

export const LinkedInLogo = React.memo(({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 101 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1944_9987)">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.8181 99.9922H89.5959C95.7324 99.9922 100.707 95.0176 100.707 88.8811V11.1033C100.707 4.9668 95.7324 -0.0078125 89.5959 -0.0078125H11.8181C5.68164 -0.0078125 0.707031 4.9668 0.707031 11.1033V88.8811C0.707031 95.0176 5.68164 99.9922 11.8181 99.9922Z" fill="#007EBB" />
      <path fillRule="evenodd" clipRule="evenodd" d="M86.8199 86.105H71.9805V60.8302C71.9805 53.9005 69.3474 50.028 63.8625 50.028C57.8957 50.028 54.7783 54.058 54.7783 60.8302V86.105H40.4773V37.9569H54.7783V44.4424C54.7783 44.4424 59.0783 36.4859 69.2956 36.4859C79.5083 36.4859 86.8199 42.7224 86.8199 55.6206V86.105ZM23.4162 31.6523C18.545 31.6523 14.5977 27.674 14.5977 22.7675C14.5977 17.8611 18.545 13.8828 23.4162 13.8828C28.2874 13.8828 32.2324 17.8611 32.2324 22.7675C32.2324 27.674 28.2874 31.6523 23.4162 31.6523ZM16.0318 86.105H30.944V37.9569H16.0318V86.105Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1944_9987">
        <rect width="100" height="100" fill="white" transform="translate(0.707031)" />
      </clipPath>
    </defs>
  </svg>
));

LinkedInLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
LinkedInLogo.defaultProps = {
  width: 101,
  height: 100,
};

export const LinkedInLogo24 = React.memo(() => <LinkedInLogo width={24} height={24} />);
export const LinkedInLogo40 = React.memo(() => <LinkedInLogo width={40} height={40} />);
export const LinkedInLogo120 = React.memo(() => <LinkedInLogo width={120} height={120} />);

export const LinkedInIconWhite = React.memo(({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1944_10020)">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.48481 16H14.9293C15.9111 16 16.707 15.2041 16.707 14.2222V1.77778C16.707 0.795938 15.9111 0 14.9293 0H2.48481C1.50297 0 0.707031 0.795938 0.707031 1.77778V14.2222C0.707031 15.2041 1.50297 16 2.48481 16Z" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4852 13.7782H12.1109V9.73424C12.1109 8.62549 11.6896 8.00589 10.8121 8.00589C9.85738 8.00589 9.35859 8.65068 9.35859 9.73424V13.7782H7.07043V6.07451H9.35859V7.1122C9.35859 7.1122 10.0466 5.83915 11.6814 5.83915C13.3154 5.83915 14.4852 6.83698 14.4852 8.9007V13.7782ZM4.34065 5.06577C3.56126 5.06577 2.92969 4.42925 2.92969 3.64421C2.92969 2.85918 3.56126 2.22266 4.34065 2.22266C5.12005 2.22266 5.75124 2.85918 5.75124 3.64421C5.75124 4.42925 5.12005 5.06577 4.34065 5.06577ZM3.15914 13.7782H5.54511V6.07451H3.15914V13.7782Z" fill="#0078D4" />
    </g>
    <defs>
      <clipPath id="clip0_1944_10020">
        <rect width="16" height="16" fill="white" transform="translate(0.707031)" />
      </clipPath>
    </defs>
  </svg>
));

LinkedInIconWhite.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
LinkedInIconWhite.defaultProps = {
  width: 17,
  height: 16,
};
